import {
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React, { useState } from "react";

const LoginForm = ({
  loginInfo,
  handleChange,
  handleSubmit,
}: {
  loginInfo: { email: string; password: string };
  handleChange(type: string, value: string): void;
  handleSubmit(): void;
}) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <Grid
      container
      display="flex"
      flexDirection="row"
      spacing={3}
      justifyContent="center"
      alignItems="center"
      p={4}
    >
      <Grid size={{ xs: 10, md: 8 }}>
        <TextField
          size="small"
          placeholder="Ingrese email"
          fullWidth
          value={loginInfo.email}
          onChange={({ target: { value } }) => handleChange("email", value)}
        />
      </Grid>
      <Grid size={{ xs: 10, md: 8 }}>
        <FormControl fullWidth size="small">
          <OutlinedInput
            type={showPassword ? "text" : "password"}
            placeholder="Ingresar contraseña"
            className="f-s-14"
            onKeyUp={(e) => e.key === "Enter" && handleSubmit()}
            value={loginInfo.password}
            onChange={({ target: { value } }) =>
              handleChange("password", value)
            }
            endAdornment={
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)}>
                  <span className="material-symbols-rounded">
                    {showPassword ? "visibility" : "visibility_off"}
                  </span>
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default LoginForm;
